import React from "react";
import { PaRequirementsList } from "../components/PaRequirementsList";

export const PaRequirementsGeneralTab = () => {
  return <PaRequirementsList />;
};
